module.exports = __webpack_public_path__ + "static/media/me.231104cb.jpeg";